var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupplierReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99984 7.99998C9.84079 7.99998 11.3332 6.5076 11.3332 4.66665C11.3332 2.8257 9.84079 1.33331 7.99984 1.33331C6.15889 1.33331 4.6665 2.8257 4.6665 4.66665C4.6665 6.5076 6.15889 7.99998 7.99984 7.99998Z",
    stroke: "#1E293B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8065 10.4933L10.4465 12.8534C10.3532 12.9467 10.2665 13.12 10.2465 13.2467L10.1199 14.1467C10.0732 14.4733 10.2999 14.7 10.6265 14.6533L11.5265 14.5267C11.6532 14.5067 11.8332 14.42 11.9199 14.3267L14.2799 11.9667C14.6865 11.56 14.8799 11.0867 14.2799 10.4867C13.6865 9.89334 13.2132 10.0867 12.8065 10.4933Z",
    stroke: "#1E293B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4668 10.8333C12.6668 11.5533 13.2268 12.1133 13.9468 12.3133",
    stroke: "#1E293B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.27344 14.6667C2.27344 12.0867 4.84012 10 8.00012 10C8.69346 10 9.3601 10.1 9.9801 10.2867",
    stroke: "#1E293B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupplierReport);
export default __webpack_public_path__ + "static/media/SupplierReport.63f4a56f88f1c00738eb2fa2d2d5b2a8.svg";
export { ForwardRef as ReactComponent };